export function getDisplayCurrency(region) {
  const r = (region || "").trim();
  if (!r) return "AED";

  const lower = r.toLowerCase();
  if (lower === "all" || lower === "all regions") return "AED";

  if (r === "Professional Signs" || r === "ProSigns KSA") return "SAR";
  if (r === "ProSigns Qatar") return "QAR";
  if (r === "ProSigns Oman") return "OMR";

  return "AED";
}

